let owlParams = {
  items: 1,
  loop: false,
  nav: true,
  dots: false,
  navText: [
    `<svg width="100%" height="auto" viewbox="0 0 80 80"><use xlink:href="#icon-normal-right"></use></svg>`,
    `<svg width="100%" height="auto" viewbox="0 0 80 80"><use xlink:href="#icon-normal-right"></use></svg>`,
  ],
};

function initCarousel() {
  $(".owl-carousel").each(function () {
    let tmpParams = $.extend(true, {}, owlParams);

    $.each($(this).data(), function (i, v) {
      // if ((i.indexOf('mobile') === 0)) {
      // var tmp = i.charAt(6).toLowerCase() + i.substr(7);
      // tmpParams['responsive'][0][tmp] = v;
      // } else {
      tmpParams[i] = v;
      // tmpParams['responsive'][992][i] = v;
      // }
    });

    if (tmpParams["svgArrow"]) {
      tmpParams["navText"] = [
        `<svg width="100%" height="auto" viewbox="0 0 32 32"><use xlink:href="#${tmpParams["svgArrow"]}"></use></svg>`,
        `<svg width="100%" height="auto" viewbox="0 0 32 32"><use xlink:href="#${tmpParams["svgArrow"]}"></use></svg>`,
      ];
    } else if (tmpParams["arrow"]) {
      tmpParams["navText"] = [
        '<img src="' + tmpParams["arrow"] + '"/>',
        '<img src="' + tmpParams["arrow"] + '"/>',
      ];
    }

    $(this)
      // .on('initialized.owl.carousel changed.owl.carousel', function(e) {
      // if (!e.namespace) return;
      // var current = e.relatedTarget.relative(e.relatedTarget.current()) + 1;
      // var total = e.relatedTarget.items().length;

      // $(e.currentTarget).closest('.owl-wrapper').find('.pagination-pages').html(
      // '<b>' + str_pad(String(current), 2, '0', 'STR_PAD_LEFT') + '</b>/' +
      // str_pad(String(total), 2, '0', 'STR_PAD_LEFT')
      // );

      // $(e.currentTarget).closest('.owl-wrapper').find('.pagination-line').css('paddingRight', String((total - current) / total * 100) + '%' );
      // })
      .on("translated.owl.carousel", function (e) {
        $(window).trigger("scroll");
      })
      .on("initialized.owl.carousel", function (e) {})
      .owlCarousel(tmpParams);
  });
}
